<template>
  <div>
    <div class="position">
      <span
        >您现在的位置：<a href="/">首页</a> > 西安12345政务服务便民热线
        >诉求列表</span
      >
      <div>
        <span>
          <a href="/">首页</a>
          <span>/</span>
        </span>
        <span>
          <a>互动</a>
        </span>
      </div>
    </div>
    <div class="container">
      <div class="left">
        <div class="head-box">
          <div class="list-name">诉求列表</div>
          <div class="search-box">
            <el-date-picker
              v-model="time"
              type="daterange"
              format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              size='mini'
              @change="selectTime"
              :clearable='false'
              style="margin-right:10px"
            />
            <el-input
              type="search"
              class="list-search"
              size="small"
              v-model="search"
              placeholder="请输入信件名称关键字"
            />
            <el-button type="primary" class="list-button" round @click="searchList">查询</el-button>
            <!-- <el-button type="info" v-else disabled class="list-button1" round >查询</el-button> -->
          </div>
        </div>
        <div class="line-box">
          <div class="active-line"></div>
          <div class="line"></div>
        </div>
        <div v-if="registerWin" style="width:100%;color:red;text-align: center;margin-bottom: 20px">本界面仅做浏览用途，若您需要提交诉求，请先进行 <a
                @click="getSignUrl" class="aActive">身份认证</a></div>
        <div class="list-content">
          <el-table
            :data="tableData"
            v-loading="loading"
            :header-cell-style="{
              background: '#E9F6FF',
              fontSize: '16px',
              color: '#306BBB',
              fontFamily: 'siyuan',
              fontWeight: 'bold',
            }"
            @row-click="clickRow"
            :row-class-name="tableRowClassName"
          >
            <el-table-column
              prop="orderNo"
              label="诉求编号"
              label-class-name="label-class"
              show-overflow-tooltip
              :formatter="orderFormat"
              width="180"
              v-if="!isCollapse"
            >
            </el-table-column>
            <el-table-column
              prop="title"
              label="诉求标题"
              show-overflow-tooltip
            >
            </el-table-column>
<!--            <el-table-column-->
<!--              prop="orderState"-->
<!--              label="处理状态"-->
<!--              width="150"-->
<!--              align="center"-->
<!--              :formatter="stateFormat"-->
<!--              v-if="!isCollapse"-->
<!--            >-->
<!--            </el-table-column>-->
            <el-table-column
                    prop="orderStateName"
                    label="处理状态"
                    width="150"
                    align="center"
                    v-if="!isCollapse"
            >
            </el-table-column>
            <el-table-column
              prop="sourceTwo"
              label="诉求来源"
              width="150"
              align="center"
              v-if="!isCollapse"
            >
            </el-table-column>
            <el-table-column prop="createTime" label="诉求时间" width="180" :formatter="dateFormat" v-if="!isCollapse">
            </el-table-column>
          </el-table>
          <div class="pagination-box pagination">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="params.pageNum"
              :page-size="10"
              layout="total,prev, next,jumper"
              :total="allSum"
              prev-text="上一页"
              next-text="下一页"
            >
            </el-pagination>
          </div>
          <div class="pagination-box pagination2">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="params.pageNum"
                :page-size="10"
                layout="total,prev, pager, next,jumper"
                :total="allSum"
                prev-text="上一页"
                next-text="下一页"
              >
              </el-pagination>
          </div>
        </div>
      </div>
      <div class="right">
        <hotline />
      </div>
    </div>
  </div>
</template>

<script>
import hotline from "@/components/hotline";
import "@/assets/styles/loc.css";
export default {
  name: "orderList",
  data() {
    return {
      loading:false,
      search: "",
      allSum: 0,
      tableData: [],
      params: {
        beginTime: "",
        endTime: "",
        telephone: "",
        tokenKey: "1",
        random: "",
        title: "",
        userId: "",
        orderState: "",
        pageNum: 1,
        pageSize: 10,
      },
      currentPage: 1,
      screenWidth:document.body.clientWidth, // 屏幕宽度
      timer: false,
      time:[],
      registerWin:true
    };
  },
  components: {
    hotline,
  },
  computed: {
    isCollapse: {
      get () {
        return this.screenWidth < 768
      },
      set () {
      }
    }
  },
  watch: {
    screenWidth (val) {
      if (!this.timer) {
        this.screenWidth = val
        if (this.screenWidth < 768) {
          this.isCollapse = true
        }
        this.timer = true
        let that = this
        setTimeout(function () {
          that.timer = false
        }, 400)
      }
    }
  },
  methods: {
    searchList(){
      this.params.title =this.search;
      this.params.pageNum = 1;
      this.getList();
    },
    handleSizeChange(val) {
     //分页  size 改变调用
      this.params.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      // 分页 当前页改变 调用
      this.params.pageNum = val;
      this.getList();
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "odd-row";
      } else {
        return "even-row";
      }
    },
    clickRow(row, column, event) {
      sessionStorage.setItem("order-row",JSON.stringify(row));
      sessionStorage.setItem("beginTime",this.params.beginTime);
      sessionStorage.setItem("endTime",this.params.endTime);
      this.$router.push({
        name: "orderInfo",
      });
    },
    getTime(){
      if(sessionStorage.getItem("beginTime")&&sessionStorage.getItem("endTime")){
        this.time[0]=sessionStorage.getItem("beginTime");
        this.time[1]=sessionStorage.getItem("endTime");
      }else{
        this.time[0]=this.moment().subtract('days', 90).format('YYYY-MM-DD')+' 00:00:00';//90天前
        this.time[1]=this.dateFormat2("yyyy-MM-dd", new Date())+' 23:59:59';
      }
      this.params.beginTime=this.time[0];
      this.params.endTime=this.time[1];
    },
    selectTime(vals) {
      if(vals){
        this.params.beginTime = this.dateFormat2("yyyy-MM-dd", vals[0])+' 00:00:00';
        this.params.endTime = this.dateFormat2("yyyy-MM-dd", vals[1])+' 23:59:59';
      }
    },
    //获取数据
    getList() {
      this.loading = true;
      this.params.random = this.generateUUID();
      let telephone = localStorage.getItem('callPhone')
      this.gwCommunication('/portal/orderApi/hianddata_get',this.params,telephone,(res) => {
        this.loading = false;
        if (res.data.code == 200) {
          this.tableData = res.data.data.data;
          this.allSum = res.data.data.allSum;
        } else {
          this.tableData = []
          this.allSum = 0
          this.$message({
            type: "info",
            message: "暂无数据",
          });
        }
      })
    },
    //日期格式化
    dateFormat(row, column, cellValue, index){
        return this.formatDateTime(cellValue)
    },
    //状态格式话
    stateFormat(row, column, cellValue, index){
        return this.formatState(cellValue)
    },
    //编号格式话
    orderFormat(row, column, cellValue, index){
         if(cellValue == ''||cellValue == undefined){
            return "************";
        }else{
            return cellValue;
        }
    }
  },

  created() {
      // this.params.telephone = "15035792103";
      // this.params.userId = "15035792103";
      // this.getList();
    // this.params.telephone = "18829058516";
    // this.params.userId = "18829058516";
    // this.params.telephone = "18220685504";
    // this.params.userId = "18220685504";
    // this.params.telephone = "15129030704";
    // this.params.userId = "15129030704";
    // this.getList();
    this.getTime();

    let callPhone = localStorage.getItem("callPhone")
    if(callPhone){
      this.registerWin=false;
      this.params.telephone = callPhone;
      this.params.userId = callPhone;
      localStorage.setItem('orderType1','1')
      this.$store.commit('isLogin','1')
      if(this.params.telephone){
        this.getList();
      }
      return;
    }

    let flag = this.getUrlParams("flag");
    if (flag) {
      this.login();
    }else{
      this.registerWin=true
    }

    let code = this.getUrlParams("code");
    // let code = 'dsfsdfdv';
    if(code){
      this.getUserInfoNew(code,res=>{
        if (res.code == 200) {
              this.registerWin=false;
              this.params.telephone = res.data.callPhone;
              this.params.userId = res.data.callPhone;
              if(this.params.telephone){
                this.getList();
              }
        }
      });
    }
    // this.getUserInfo((res) => {
    //   if (res.code == 401) {
    //     this.registerWin=true;
    //   }else if (res.code == 200) {
    //     this.registerWin=false;
    //     this.params.telephone = res.data.callPhone;
    //     this.params.userId = res.data.callPhone;
    //     if(this.params.telephone){
    //       this.getList();
    //     }
    //   }
    //
    // });
  },
};
</script>

<style scoped>
@media screen and (max-width: 1200px){
      /* .container{
        position: static;
        padding: 0px;
    } */
}
@media screen and (max-width: 1150px){
    .container{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        margin: 0px;
        padding: 0px;
    }

    body .left{
        width: 95%;
        margin-right:0px;
         padding:0px;
        order: 2;
        /* display: flex; */
        justify-content: center;

    }
    body .right{
        width: 95%;
        order: 1;
        margin-bottom: 15px;
    }
    body .boxCenter {
        display: inline;
        margin-left: 0px;
        padding:0px 10px 20px 40px;
        padding: 52px 36px;

    }
    body .f {
      margin-left: 0px;
    }
    body .search-box .el-input{
        width: 180px;
    }
    body .list-button{
        width: 60px;
    }
    body .list-name{
        font-size: 17px;
    }
    body .pagination2{
        display: none;
    }
    body .pagination{
        display: flex;
    }
}
.aActive{
  cursor:pointer;
  color: #2d85fd;
  font-weight: 400;
  border-bottom: 1px solid #2d85fd;
  padding: 0 10px;
}
.container {
  display: flex;
  justify-content: space-between;
}
.left {
  width: 75%;
  /* height: 723px; */
  background: #ffffff;
  flex-flow: row wrap;
  display: flex;
  /* 上下 */
  align-content: space-between;
  margin-right: 20px;
  padding: 0px 23px 0px 23px;
}
.right {
  width: 25%;
}
.head-box {
  width: 100%;
  display: flex;
  height: 62px;
  justify-content: space-between;
  align-items: center;
  background-color: #ffffff;
}
.search-box .el-input__inner {
  height: 30px !important;
}
.search-box .el-input {
  width: 185px;
}
.list-button {
  width: 92px;
  height: 30px;
  background: linear-gradient(0deg, #306bbb, #2d85fd);
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  padding: 6px 0px 10px 0px;
  margin-left: 11px;
}
.list-button1 {
  width: 92px;
  height: 30px;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  padding: 6px 0px 10px 0px;
  margin-left: 11px;
}
.list-name {
  font-size: 20px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #306bbb;
  line-height: 52px;
}
.line {
  width: 100%;
  border-bottom: 1px solid #e6e6e6;
  margin: 1px 0 16px;
}
.list-content {
  width: 100%;
  height: 658px;
  background-color: #ffffff;
}
.label-class {
  background-color: #e9f6ff;
}
.pagination-box {
  display: flex;
  justify-content: center;
  border: 1px solid #e3e3e3;
  width: 90%;
  margin: 17px auto 0;
  padding: 5px 0;
}
/* app */
.pagination{
    display: none;
}
.active-line {
  width: 90px;
  height: 3px;
  background: #306bbb;
}
.line-box {
  width: 100%;
  display: flex;
}
</style>
<style>
.el-table .odd-row {
  background: #ffffff;
  cursor: pointer;
}
.el-table .even-row {
  background: #f1f6ff;
  cursor: pointer;
}
.container .cell {
  height: 28px;
}
.el-table__body {
  width: 100% !important;
}
</style>
